import { Button, UIText2 } from '@cian/ui-kit';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';
import { IStyleProps } from '@cian/utils';

import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import { Component } from 'react';

import { IAbUseExperiment } from 'shared/types/abUseExperiments';
import { TUser } from 'shared/types/user';

import * as style from './index.css';
export interface ILikeButtonProps {
  isActive: boolean;

  buttonClassName?: string;
  buttonStyle?: IStyleProps;

  toggleActivity(value: boolean): void;
}

export interface ILikeButtonContext {
  user: TUser;
  api: {
    favoritesLimitForUnauthUser?: number;
  };
  abUseExperiments: IAbUseExperiment[];
}

export interface ILikeButtonState {
  isActive: boolean;
}

export class LikeButton extends Component<ILikeButtonProps, ILikeButtonState> {
  public context: ILikeButtonContext;

  public static contextTypes = {
    api: PropTypes.object,
    user: PropTypes.object,
    abUseExperiments: PropTypes.arrayOf(
      PropTypes.shape({ experimentName: PropTypes.string, string: PropTypes.string }),
    ),
  };

  public constructor(props: ILikeButtonProps) {
    super(props);

    this.state = {
      isActive: props.isActive,
    };
  }

  public render() {
    const { buttonClassName, buttonStyle } = this.props;
    const { isActive } = this.state;

    return (
      <Button
        beforeIcon={
          <span className={classNames(style['button'], buttonClassName, !isActive && buttonStyle)}>
            {isActive ? (
              <IconToggleHeartOn16 color="icon-negative-default" />
            ) : (
              <IconToggleHeartOff16 color="icon-secondary-default" />
            )}
            <UIText2 color="text-primary-default" fontWeight="700">
              {isActive ? 'В избранном' : 'В избранное'}
            </UIText2>
          </span>
        }
        size="XS"
        theme="stroke_secondary"
        onClick={this.handleClick}
      />
    );
  }

  protected handleClick = () => {
    this.setState({
      isActive: !this.state.isActive,
    });

    this.props.toggleActivity(!this.state.isActive);
  };
}
